module.exports = __webpack_public_path__ + "static/media/downArrow.a6a5b5c6.svg";